/** Roles del sistema. Agregar uno aquí obliga a definir sus permisos. */
export const ROLES = ['admin', 'seller_agent', 'accountant'] as const

export type Role = (typeof ROLES)[number]

/** Etiquetas legibles para mostrar en la interfaz (en español, las ve el usuario). */
export const ROLE_LABELS: Record<Role, string> = {
  admin: 'Administrador',
  seller_agent: 'Vendedor',
  accountant: 'Contador',
}

/** Usuario autenticado. */
export interface User {
  id: string
  fullName?: string | null
  name: string | null
  email: string
  role: Role
  mustChangePassword?: boolean
}

/** Datos que se envían al iniciar sesión. */
export interface LoginCredentials {
  email: string
  password: string
}

/**
 * Respuesta esperada del backend al autenticarse.
 *
 * 👉 PENDIENTE: ajustar cuando se conozca el contrato real del backend.
 *    Si se adopta la opción recomendada en docs/04-permisos.md, el backend
 *    devolverá también la lista de permisos del usuario en lugar de que el
 *    frontend la deduzca del rol.
 */
export interface ApiAuthResponse {
  accessToken: string
  refreshToken: string
  user: Omit<User, 'fullName' | 'role' | 'mustChangePassword'> & {
    fullName: string | null
    roles: string[]
    mustChangePassword?: boolean
    lastLoginAt?: string | null
  }
}
